import React, { Component } from "react";
import { Provider } from "react-redux";
import GlobalState from "../../reducers/reducers";
import EditorApp from "./EditorApp";
import { createStore, compose, applyMiddleware } from "redux";
import { thunk as thunkMiddleware } from "redux-thunk";
import { recentActionsMiddleware } from "../components/ai-chat/recentActions";
import IdealStudio from "../../core/editor/main";
import { setStore } from "../../common/environment_config.es6";
import { installAideaBridge } from "../../common/aideaBridge.es6";
import stateAtomicDemo from "../../reducers/stateAtomicDemo";
export default class ReduxProvider extends Component {
  constructor(props) {
    super(props);
    // Dev flag: `?atomicDemo=1` boots with the AtomicBoxPlugin demo state for
    // manual testing of nested-track UI + field-level animations. No-op without
    // the URL param, so safe to keep in production builds.
    const isAtomicDemo =
      typeof window !== "undefined" &&
      new URL(window.location.href).searchParams.get("atomicDemo") === "1";
    this.initialState = isAtomicDemo ? stateAtomicDemo : IdealStudio.InitialState;
    this.store = this.configureStore();
  }

  render() {
    return (
      <Provider store={this.store}>
        <div style={{ height: "100%" }}>
          <EditorApp id="app" store={this.store} />
        </div>
      </Provider>
    );
  }

  configureStore() {
    const composeEnhancers =
      (process.env.NODE_ENV !== "production" &&
        typeof window !== "undefined" &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
      compose;

    const store = createStore(
      GlobalState,
      this.initialState,
      composeEnhancers(applyMiddleware(thunkMiddleware, recentActionsMiddleware))
    );

    setStore(store);
    installAideaBridge(store);

    IdealStudio.Plugins.loadAll();
    if (module.hot) {
      // Enable Webpack hot module replacement for reducers
      module.hot.accept("../../reducers/reducers", () => {
        const nextRootReducer = require("../../reducers/reducers").default;
        store.replaceReducer(nextRootReducer);
      });
    }

    return store;
  }
}
